document.addEventListener('DOMContentLoaded', () => {
  initQuickCart();
});

function initQuickCart() {
  // Use event delegation to catch clicks on any quick add button dynamically
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quick-cart-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // Toggle loading state
    if (btn.classList.contains('loading')) return;
    btn.classList.add('loading');

    // Build payload to add variant and render the side-cart section dynamically
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', 'side-cart');

    fetch('/cart/add', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      }
    })
    .then(res => {
      if (!res.ok) throw new Error('Failed to add product to cart');
      return res.json();
    })
    .then(data => {
      btn.classList.remove('loading');
      
      // Call theme's native ajaxCart updater if available to refresh header counts and open cart drawer
      if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
        ajaxCart.load(data);
      } else {
        // Fallback: Redirect to cart page or dispatch standard custom event if ajaxCart isn't initialized
        window.location.href = '/cart';
      }
    })
    .catch(err => {
      btn.classList.remove('loading');
      console.error('Error adding variant to cart:', err);
      
      // Dispatch theme's native error handler if available, else show basic alert
      alert('Could not add item to cart. Please try again.');
    });
  });
}
